<script setup>
// 1. 부모로부터 'topic'을 props로 받습니다.
const props = defineProps({
  topic: {
    type: String,
    required: true,
  },
});

// 2. 부모에게 'openTooltip' 신호를 보낼 것이라고 선언합니다.
const emit = defineEmits(['openTooltip']);
</script>

<template>
  <button type="button" @click="emit('openTooltip', props.topic)">
    <i class="btn-exp">설명</i>
  </button>
</template>
